import {
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_DATA,
  SET_AUTH,
  SET_NEW_PROJECT,
  SET_VERIFICATION_DOCUMENT,
  SET_COVER_IMAGE,
  SET_PROFILE_IMAGE,
} from "../types";

const initialState = {
  loading: false,
  errors: null,
  authorised: false,
  userData: { projects: [] },
  auth: {},
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        loading: false,
        errors: null,
      };
    case LOADING_UI:
      return {
        ...state,
        loading: true,
      };
    case SET_DATA:
      return {
        ...state,
        userData: { ...state.userData, ...action.payload.userData },
      };
    case SET_AUTH:
      return {
        ...state,
        loading: false,
        auth: { token: action.payload.token },
        authorised: true,
        userData: { ...state.userData, ...action.payload.user },
      };
    case SET_NEW_PROJECT:
      return {
        ...state,
        userData: {
          ...state.userData,
          projects: [...state.userData.projects, action.payload.project],
        },
      };
    case SET_VERIFICATION_DOCUMENT:
      return {
        ...state,
        userData: {
          ...state.userData,
          verificationDocument: action.payload.data,
        },
      };
    case SET_PROFILE_IMAGE:
      return {
        ...state,
        userData: {
          ...state.userData,
          profileImage: action.payload.data,
        },
      };
    case SET_COVER_IMAGE:
      return {
        ...state,
        userData: {
          ...state.userData,
          coverImage: action.payload.data,
        },
      };
    default:
      return state;
  }
}
